<template>
  <div class="text-center loading">
    <b-spinner class="spinner" label="Spinning" />
    <span>Loading</span>
  </div>
</template>

<script lang="ts">
import {BSpinner} from "bootstrap-vue-next";

export default {
  components:{
    BSpinner
  }
}
</script>

<style lang="scss">
.loading {
  height: 100%;
  top: 0;
  left: 0;
  width: 100%;
  position: absolute;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .spinner {
    width: 3rem;
    height: 3rem;
    margin-bottom: 1rem;
    color: #6777ef;
  }

  span {
    font-size: 1.4rem;
  }
}
</style>
